"use client";

import {
  metadata,
  networks,
  projectId,
  solanaWeb3JsAdapter,
  wagmiAdapter,
} from "@/services/web3/wagmi-config";

import { createAppKit } from "@reown/appkit/react";
import { PropsWithChildren } from "react";
import { cookieToInitialState, WagmiProvider, type Config } from "wagmi";

/**
 * @see https://docs.walletconnect.com/web3modal/nextjs/about
 */

if (!projectId) {
  throw new Error("Project ID is not defined");
}

createAppKit({
  adapters: [wagmiAdapter, solanaWeb3JsAdapter],
  projectId,
  networks,
  metadata,
  themeMode: "dark",
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
  // featuredWalletIds: [
  //   // MetaMask
  //   "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
  //   // Trust Wallet
  //   "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
  //   // Exodus
  //   "e9ff15be73584489ca4a66f64d32c4537711797e30b6660dbcb71ea72a42b1f4",
  //   // UniSwap
  //   "c03dfee351b6fcc421b4494ea33b9d4b92a984f87aa76d1663bb28705e95034a",
  //   // Binance Web3 Wallet
  //   "8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4",
  // ],
});

interface Props {
  readonly cookies: string | null;
}

export default function Web3ModalProvider(props: PropsWithChildren<Props>) {
  let initialState;
  try {
    initialState = cookieToInitialState(
      wagmiAdapter.wagmiConfig as Config,
      props.cookies,
    );
  } catch (error) {
    console.log("cookieToInitialState Error:", error);
  }

  return (
    <WagmiProvider
      config={wagmiAdapter.wagmiConfig as Config}
      initialState={initialState}
    >
      {props.children}
    </WagmiProvider>
  );
}
